const firebaseConfig = {
  apiKey: window.BETCLOUD_ENV.REACT_APP_FIREBASE_APIKEY,
  authDomain: window.BETCLOUD_ENV.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: window.BETCLOUD_ENV.REACT_APP_FIREBASE_PROJECTID,
};

export default firebaseConfig;
